import { render, staticRenderFns } from "./BaseTLTreeCheckView.vue?vue&type=template&id=2d9019d4&"
import script from "./BaseTLTreeCheckView.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTreeCheckView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports